import { render, staticRenderFns } from "./PosTransactionsTable.vue?vue&type=template&id=3bb2bfce&scoped=true&"
import script from "./PosTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./PosTransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2bfce",
  null
  
)

export default component.exports